import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Goal } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_GOAL_BY_ID = 'get-goal-by-id';

export const useGetGoalById = (id: number) => {
  return usePermittedQuery<Goal>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/goal/${id}`,
    {},
    [GET_GOAL_BY_ID],
    {
      enabled: typeof id === 'number' && id >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
